import React from 'react'
import {useField} from "formik";
import styles from './Time.module.scss';
import { useTranslation } from "react-i18next";
import {HelpText} from "../HelpText/HelpText";

export const Time = ({ label, required, helpText, ...props }) => {
    const { t } = useTranslation();
    const [field, meta] = useField(props);

    return (
        <div className={styles.timeContainer}>
            <div>
                {label &&
                    <label htmlFor={props.id || props.name} className={styles.timeLabel}>
                        {label}

                        {required && <span className={styles.required}>*</span>}
                    </label>
                }

                <input
                    {...field}
                    {...props}
                    id={props.id || props.name}
                    type="time"
                    className={styles.timeInput}
                />
            </div>

            {helpText &&
                <HelpText>{helpText}</HelpText>
            }

            {(meta.touched && meta.error) &&
                <div className={styles.error}>{t('input_component.is_required')}</div>
            }
        </div>
    );
};
